// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__QXHnu","title":"InfoRow_title__g-KBI"};